module.exports = __webpack_public_path__ + "fonts/font.2815b26.woff2";